import { render, staticRenderFns } from "./JdsPipelineStageBadge.vue?vue&type=template&id=8c5ded40&scoped=true&"
import script from "./JdsPipelineStageBadge.vue?vue&type=script&lang=ts&"
export * from "./JdsPipelineStageBadge.vue?vue&type=script&lang=ts&"
import style0 from "./JdsPipelineStageBadge.vue?vue&type=style&index=0&id=8c5ded40&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5ded40",
  null
  
)

export default component.exports